import { useContext } from 'react';
import { Outlet } from 'react-router-dom';

import FooterNavigation from '@/components/navigation/FooterNavigation';
import MenuNavigation from '@/components/navigation/MenuNavigation';
import { Sidebar, SidebarContext } from '@destination/components';

export const Root = () => {
  const { isCollapsed } = useContext(SidebarContext);

  return (
    <>
      <Sidebar
        menuItems={<MenuNavigation />}
        footerItems={<FooterNavigation />}
      />
      <main
        className={`${
          !isCollapsed ? 'ml-[150px]' : 'ml-12'
        } small-screen:ml-12 p-8 min-h-screen`}
      >
        <Outlet />
      </main>
    </>
  );
};
